import { PostReviewFieldError, PostReviewResponseWithError } from '../types';

export const postReviewResponseTransform = (data: PostReviewResponseWithError) => {
  return isErrorResponseData(data) ? tryTransformErrorResponse(data) : data;
};

export const isErrorResponseData = (data: PostReviewResponseWithError) =>
  typeof data === 'object' && data !== null && Object.keys(data).includes('errors');

export const tryTransformErrorResponse = (data: PostReviewResponseWithError) => {
  const { errors } = data;
  let result = null;
  if (errors instanceof Object && errors !== null) {
    const processedErrors = Object.keys(errors).reduce((prev, key) => {
      if (errors[key] instanceof Array) {
        prev.push(
          ...errors[key]
            .filter((r) => typeof r.message === 'string')
            .map(
              (r) =>
                ({
                  fieldKey: key,
                  message: r.message,
                  errorKey: r.error,
                }) as PostReviewFieldError,
            ),
        );
      }

      return prev;
    }, [] as PostReviewFieldError[]);
    if (processedErrors.length > 0) {
      result = { postReviewErrors: processedErrors };
    }
  }
  return result;
};
